import pink from "@material-ui/core/colors/pink"
import yellow from "@material-ui/core/colors/yellow"
import green from "@material-ui/core/colors/green"
import amber from "@material-ui/core/colors/amber"
import { hexToRgbA } from "../../utils/color"

const styles = theme => ({
  profileDialog: {
    // zIndex: 1301
  },
  dialogPaper: {
    width: "100%",
    maxWidth: 800,
  },
  email: {
    display: "flex",
  },
  dialogContent: {
    padding: theme.spacing(2),
    paddingTop: [theme.spacing(2), "!important"],
  },
  dialogActions: {
    padding: theme.spacing(2),
    paddingTop: 0,
    margin: 0,
  },
  dialogActionsAction: {
    margin: 0,
  },
  profileImage: {
    width: "100%",
    verticalAlign: "middle",
  },
  avatarWrapper: {
    width: "100%",
    paddingTop: "100%",
    position: "relative",
    "&:hover $addImageOverlay": {
      opacity: 1,
    },
  },
  imageOverlay: {
    "&:before": {
      position: "absolute",
      zIndex: 1,
      top: "0",
      left: "0",
      bottom: "0",
      right: "0",
      color: "white",
      textTransform: "uppercase",
      fontWeight: "500",
      fontFamily: "Roboto",
      fontSize: "24px",
      padding: "12px",
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "center",
    },
  },
  imageOverlayPreferred: {
    "&:before": {
      content: "'Preferred'",
      background: `linear-gradient(transparent, ${hexToRgbA(
        yellow[700],
        0.75
      )})`,
    },
  },
  imageOverlayDoNotUse: {
    "&:before": {
      content: "'Do Not Use'",
      background: `linear-gradient(transparent, ${hexToRgbA(
        theme.palette.secondary.main,
        0.75
      )})`,
    },
  },
  addPhotoIcon: {
    color: "#fff",
    width: "1.6em",
    height: "1.6em",
  },
  avatarImage: {
    width: "100%",
    top: 0,
    left: 0,
    position: "absolute",
    borderRadius: 0,
    fontSize: "4em",
    fontFamily: '"Oswald"',
    backgroundColor: theme.palette.grey[400],
  },
  avatar: {
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    position: "absolute",
    borderRadius: 0,
    fontSize: "4em",
    fontFamily: '"Oswald"',
    backgroundColor: theme.palette.grey[400],
  },
  avatarUploadOverlay: {
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: "1",
    backgroundColor: theme.palette.action.active,
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    cursor: "wait",
  },
  addImageOverlay: {
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: "1",
    backgroundColor: theme.palette.action.disabled,
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    cursor: "pointer",
    opacity: 0,
    transition: theme.transitions.create("opacity", {
      easing: theme.transitions.easing.easeInOut,
    }),
  },
  avatarPaper: {
    position: "relative",
  },
  avatarLabel: {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    cursor: "pointer",
  },
  avatarInput: {
    opacity: 0,
    outline: "none",
  },
  nameInputs: {
    marginTop: theme.spacing(1),
  },
  headlineWrapper: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
    minHeght: 32,
  },
  headline: {
    opacity: 0.6,
    fontSize: "1em",
    display: "inline",
  },
  sectionHeadline: {
    margin: "48px 0 16px",
    borderBottom: `1px solid ${theme.palette.text.primary}`,
  },
  addButton: {
    fontSize: "0.68rem",
    minWidth: 50,
    marginLeft: theme.spacing(1),
  },
  chipWrapper: {
    display: "flex",
    flexWrap: "wrap",
  },
  collapse: {
    position: "relative",
    marginRight: 20,
  },
  arrowIcon: {
    position: "absolute",
    top: 0,
    right: 0,
    width: "0.8em",
    cursor: "pointer",
    transition: theme.transitions.create("transform", {
      easing: theme.transitions.easing.sharp,
    }),
  },
  arrowDown: {
    transform: "rotate(180deg)",
  },
  name: {
    fontSize: "1.1em",
    marginTop: theme.spacing(2),
    display: "inline-block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    width: "100%",
    textOverflow: "ellipsis",
    marginBottom: 0,
  },
  description: {
    marginTop: theme.spacing(2),
  },
  rating: {
    marginBottom: theme.spacing(2),
  },
  citiesWrapper: {
    display: "flex",
    flexWrap: "wrap",
  },
  inputWrapper: {
    display: "flex",
    alignItems: "baseline",
    marginBottom: theme.spacing(1),
  },
  autoComplete: {
    flexGrow: 1,
  },
  autoCompleteInput: {
    padding: "9px 0",
  },
  placesAutoCompleteInputInput: {
    "&::placeholder": {
      color: "#000",
      opacity: 0.42,
    },
  },
  input: {
    margin: `0 ${theme.spacing(1)}px`,
    flexBasis: 120,
  },
  fullInput: {
    marginRight: theme.spacing(1),
  },
  inputMarginBottom: {
    transform: "translateY(-14px)",
    zIndex: 2,
  },
  icons: {
    display: "flex",
    alignItems: "center",
    color: theme.palette.grey[400],
    justifyContent: "space-between",
    width: "80px",
    marginTop: theme.spacing(1),
  },
  boxIcon: {
    fontSize: "1.3em",
  },
  vehicleIcon: {
    fontSize: "1.1em",
  },
  modal: {
    position: "absolute",
    width: "50%",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    outline: "none",
    [theme.breakpoints.down("md")]: {
      width: "65%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "80%",
    },
  },
  popover: {
    pointerEvents: "none",
  },
  popoverPaper: {
    padding: theme.spacing(2),
  },
  trigger: {
    cursor: "pointer",
  },
  listItem: {
    padding: [0, "!important"],
  },
  listText: {
    color: "rgba(0,0,0,0.35)",
  },
  saveAndCloseButton: {
    marginLeft: theme.spacing(1),
  },
  marginBottom: {
    marginBottom: theme.spacing(2),
  },
  marginBottom2: {
    marginBottom: theme.spacing(4),
  },
  marginRight: {
    marginRight: theme.spacing(1),
  },
  marginTop: {
    marginTop: theme.spacing(2),
  },
  marginTop3: {
    marginTop: theme.spacing(3),
  },
  marginTop4: {
    marginTop: theme.spacing(4),
  },
  tabs: {
    backgroundColor: theme.palette.primary.dark,
    color: "#fff",
    marginBottom: theme.spacing(2),
    display: "flex",
  },
  tabsRoot: {
    flexGrow: 2,
  },
  tabButtonWrapper: {
    flexGrow: 1,
    flexBasis: 65,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  tab: {
    flexGrow: 1,
    minWidth: "initial",
  },
  noteArea: {
    width: "80%",
  },
  note: {
    display: "flex",
    borderBottom: "1px solid #9c9c9c",
    paddingBottom: 12,
    "&:not(:first-child)": {
      paddingTop: 12,
    },
  },
  lastNote: {
    marginBottom: theme.spacing(3),
  },
  noteContent: {
    flexGrow: "1",
    display: "flex",
    flexDirection: "column",
  },
  noteFirstLine: {
    display: "flex",
  },
  noteMessageIcon: {
    color: theme.palette.primary.dark,
    width: "0.7em",
    height: "0.7em",
  },
  noteLineText: {
    color: theme.palette.primary.dark,
    fontSize: "0.7em",
    lineHeight: "1.2em",
    padding: `0 ${theme.spacing(1)}px`,
  },
  noteLineArrowIcon: {
    width: "0.6em",
    height: "0.7em",
    cursor: "pointer",
  },
  noteBullet: {
    fontSize: "13px",
    opacity: "0.5",
    lineHeight: "1.2em",
  },
  noteTimeAgo: {
    color: "rgba(0, 0, 0, 0.5)",
    fontSize: "12px",
    padding: "0 6px",
    lineHeight: "1.3em",
  },
  noteNote: {
    color: theme.palette.text.secondary,
  },
  noteAvatar: {
    alignSelf: "center",
  },
  notesInputWrapper: {
    backgroundColor: "#f1f1f1",
    padding: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing(2),
    alignItems: "flex-end",
  },
  noteInputUnderline: {
    "&:before": {
      borderBottom: ["none", "!important"],
    },
    "&:after": {
      borderBottom: ["none", "!important"],
    },
  },
  saveNoteButton: {
    alignSelf: "flex-end",
  },
  noteMenu: {
    zIndex: 1302,
  },
  newInputWrapper: {
    flexGrow: 1,
  },
  inputWithAddButton: {
    display: "flex",
    padding: `${theme.spacing(1)}px 0`,
  },
  addIcon: {
    marginLeft: theme.spacing(1),
    display: "flex",
    alignItems: "center",
  },
  extraLine: {
    margin: "6px 0",
    display: "flex",
    alignItems: "center",
  },
  extraLineTypography: {
    flexGrow: 1,
  },
  "@global": {
    ".rdw-editor-main": {
      backgroundColor: "#f1f1f1",
    },
  },
  badgeWrapper: {
    position: "absolute",
    bottom: 10,
    right: -10,
    height: 45,
    width: 45,
    zIndex: 1,
    boxShadow:
      "0px 0px 0px -1px rgba(0, 0, 0, 0.1), 0px 2px 16px 0px rgba(0, 0, 0, 0.1), 0px 0px 2px 0px rgba(0, 0, 0, 0.1)",
    backgroundColor: theme.palette.secondary.main,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 2,
  },
  badgeImage: {
    height: 35,
  },
  switchWrapper: {
    display: "flex",
    alignItems: "center",
  },
  socialSwitchWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  vimeoWrapper: {
    display: "flex",
    alignItems: "baseline",
  },
  vimeoLabel: {
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(1),
  },
  ratingBannerIcon: {
    marginRight: theme.spacing(1),
  },
  ratingBannerText: {
    fontWeight: "600",
    color: "#fff",
    fontSize: "1.2em",
    textTransform: "uppercase",
  },
  galleryModal: {
    zIndex: 1302,
  },
  galleryWrapper: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: theme.spacing(2),
    justifyContent: "space-between",
  },
  galleryPaper: {
    width: 150,
    marginBottom: theme.spacing(2),
    position: "relative",
    "&:hover $removeIconWrapper": {
      opacity: 1,
    },
  },
  galleryThumb: {
    width: "100%",
    verticalAlign: "middle",
  },
  removeIconWrapper: {
    top: "5px",
    right: "5px",
    position: "absolute",
    cursor: "pointer",
    opacity: 0,
    zIndex: 3,
    transition: theme.transitions.create("opacity", {
      duration: theme.transitions.duration.enteringScreen,
    }),
    "&:after": {
      content: "''",
      backgroundColor: pink["A200"],
      height: "20px",
      width: "20px",
      position: "absolute",
      top: "4px",
      right: "4px",
      borderRadius: "50%",
      display: "block",
      zIndex: "0",
    },
  },
  removeIcon: {
    color: "#fff",
    width: "1.2em",
    height: "1.2em",
    position: "relative",
    zIndex: 1,
  },
  laborOnly: {
    display: "flex",
    alignItems: "center",
    color: green[400],
    marginTop: theme.spacing(3),
    fontSize: 18,
  },
  laborOnlyIcon: {
    marginLeft: theme.spacing(1),
  },
  twitterIcon: {
    color: "#1DA1F2",
  },
  descriptionWrapper: {
    paddingRight: 25,
  },
  toggleButtons: {
    display: "flex",
    alignItems: "center",
  },
  //for testing
  chipRoot: {
    border: "none",
    cursor: "default",
    padding: "0",
    display: "inline-flex",
    outline: "none",
    transition:
      "background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    whiteSpace: "nowrap",
    alignItems: "center",
    fontFamily: "Open Sans,sans-serif",
    borderRadius: 16,
    textDecoration: "none",
    justifyContent: "center",
  },
  chip: {
    backgroundColor: amber[400],
    color: "#fff",
    fontSize: "0.7125rem",
    height: 25,
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    textTransform: "uppercase",
  },
  chipLabel: {
    cursor: "inherit",
    display: "flex",
    alignItems: "center",
    userSelect: "none",
    whiteSpace: "nowrap",
    paddingLeft: 12,
  },
  spacing: {
    paddingRight: 12,
  },
  positionRate: {
    fontWeight: 700,
    display: "inline-block",
    marginLeft: theme.spacing(1),
    paddingRight: 12,
  },
  deleteIcon: {
    width: "0.9em",
    cursor: "pointer",
    marginRight: 2,
    marginLeft: -6,
  },
  connectStripeContainer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    minHeight: "40px",
  },
})

export default styles
